import FeatureCard from "@/components/site/FeatureCard";
import Reveal from "@/components/site/Reveal";
import SectionTitle from "@/components/site/SectionTitle";

/** Exemples de types d'écoles (pas de vraies écoles : aucune n'a encore donné son accord pour être citée). */
const schools = [
  { name: "Votre école", plan: "Établissement", cycles: "Primaire et Secondaire" },
  { name: "Une école primaire", plan: "Essentiel", cycles: "Primaire" },
  { name: "Un groupe scolaire", plan: "Réseau", cycles: "Plusieurs établissements" },
];

const spaces = ["Direction", "Secrétariat", "Enseignants", "Caisse"];

const points = [
  {
    icon: "ri-lock-2-line",
    title: "Chaque école chez elle",
    text: "Une école ne voit jamais les élèves, les paiements ni les notes d'une autre. Même un employé du Primaire ne voit que son cycle si vous le décidez.",
  },
  {
    icon: "ri-vip-crown-line",
    title: "Un forfait clair",
    text: "Essentiel, Établissement ou Réseau. Un rappel arrive 30 jours avant la fin de l'abonnement ; après, vos données restent consultables.",
  },
  {
    icon: "ri-stack-line",
    title: "Primaire et Secondaire",
    text: "Chaque cycle a ses classes, ses matières, son barème de notes et ses finances. Vous ouvrez un cycle quand vous en avez besoin.",
  },
  {
    icon: "ri-printer-line",
    title: "Tout s'imprime",
    text: "Reçus, cartes scolaires, certificats, bulletins, fiche des frais, état de caisse et fiches de paie, en PDF.",
  },
];

export default function PlatformSection() {
  return (
    <section id="plateforme" className="scroll-mt-28 bg-white py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="Plateforme"
          title="Une plateforme, chaque école chez elle"
          intro="WaitechEdu ouvre un espace séparé pour chaque établissement. Vous gérez votre école ; nous gérons la plateforme, les sauvegardes et les mises à jour."
        />

        <div className="mt-14 grid gap-6 lg:grid-cols-[1.15fr_1fr]">
          <Reveal>
            <div className="rounded-[1.75rem] border border-background-200 bg-background-100/60 p-5 md:p-8">
              <div className="flex justify-center">
                <div className="flex items-center gap-3 rounded-2xl bg-primary-950 px-5 py-3.5 text-white shadow-raised">
                  <i className="ri-shield-check-line text-xl text-primary-300" aria-hidden="true"></i>
                  <span>
                    <span className="block font-bold font-heading">WaitechEdu</span>
                    <span className="block text-xs text-white/75">Ouverture des écoles · forfaits · sauvegardes</span>
                  </span>
                </div>
              </div>
              {/* Liaison vers les écoles. */}
              <div className="mx-auto h-6 w-px bg-primary-300" aria-hidden="true"></div>
              <div className="mx-auto h-px w-2/3 bg-primary-300" aria-hidden="true"></div>

              <ul className="mt-6 grid gap-3 sm:grid-cols-3">
                {schools.map((s) => (
                  <li key={s.name} className="rounded-2xl border border-background-200 bg-white p-4">
                    <i className="ri-building-4-line text-xl text-primary-700" aria-hidden="true"></i>
                    <p className="mt-2 font-bold font-heading leading-snug text-foreground-950">{s.name}</p>
                    <p className="text-sm font-medium text-primary-600">{s.plan}</p>
                    <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-600">
                      <i className="ri-database-2-line" aria-hidden="true"></i>
                      Données séparées
                    </p>
                    <p className="mt-1 flex items-center gap-1.5 text-xs text-foreground-600">
                      <i className="ri-graduation-cap-line" aria-hidden="true"></i>
                      {s.cycles}
                    </p>
                  </li>
                ))}
              </ul>

              <div className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-4">
                {spaces.map((space) => (
                  <span
                    key={space}
                    className="rounded-xl border border-dashed border-background-300 bg-white px-3 py-2.5 text-center text-sm text-foreground-700"
                  >
                    {space}
                  </span>
                ))}
              </div>
              <p className="mt-4 text-center text-sm text-foreground-500">
                Des accès séparés pour chaque métier, dans chaque école
              </p>
            </div>
          </Reveal>

          <div className="grid gap-4 sm:grid-cols-2">
            {points.map((p, index) => (
              <Reveal key={p.title} delay={index * 80} className="h-full">
                <FeatureCard icon={p.icon} title={p.title}>
                  {p.text}
                </FeatureCard>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
